$(() => {

    'use strict';

    /*============================================
        Initializations
    ==============================================*/

    // AJAX
    require('./modules/ajax.js');

    // Service Worker
    require('./modules/worker.js');

    // Notifications
    require('./modules/notification.js');

    // Bootstrap
    require('./modules/bootstrap.js');

    // Datatables
    require('./modules/datatable.js');

    // Navigations
    require('./modules/navigation.js');

    // Floating Action Buttons
    require('./modules/action.js');

    // Locale Inputs
    require('./modules/input-locale.js');

    /*============================================
        Event Listeners
    ==============================================*/

    // Unused links
    $(document).on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
    });

    // Navigation header
    $('#navbar .navbar-nav').append($('#sub-navbar li:not(.dropdown)').clone().addClass('clone'));
    $('#navbar .navbar-nav').append($('#sub-navbar li:first-child').clone().addClass('clone notifications').removeClass('dropdown unread'));
    $('#navbar .navbar-nav .clone.notifications').find('a').removeAttr('data-toggle').addClass('nav-link').attr('href', "/notifications").find('i').after('Notifications').remove().find('notifications').remove();
    $('#navbar .navbar-nav').append($('<li>').addClass('nav-item clone').append($('#sub-navbar li:nth-child(2) .dropdown-menu a').clone().removeClass('dropdown-item').addClass('clone nav-link')));

    // Preloader
    $(window).on('load', function () {
        $(window).trigger('scroll');
        $('body').attr('data-loaded', true);
    });

    setTimeout(() => {
        $('body').attr('data-loaded', true);
    }, 1500);

    // Redirect to anchor
    $(window).on('load', function () {
        if (window.location.hash.trim()) {
            var target = $('.' + window.location.hash.substr(1));
            if (target.length > 0) {
                $.scrollTo(target.offset().top - 150);
            }
        }
    });

    // Specify Other Selection
    $(document).on('change', 'select', function (e) {
        if ($(this).val() && $(this).val().toLowerCase().startsWith('other')) {
            var node = $(`<input type="text" class="form-control mt-2" name="${$(this).attr('name')}_specify" placeholder="Enter ${$(this).attr('name')}..." />`);
            $(this).after(node);
            $(this).off().on('change', function () {
                if (!$(this).val().toLowerCase().startsWith('other')) {
                    node.remove();
                }
            })
        }
    });

    // Populate State & City
    if ($('select[name="state"]').length > 0 && $('select[name="city"]').length > 0) {
        $('select[name="state"]').each((index, input) => {
            $(input).customLocaleInput({
                'cityInput': $(input).closest('.row').find('select[name="city"]'),
            });
        });
    }

    // Phone Number Dropdown
    if ($('.input-phone:not(.ignore)').length > 0) {
        $('.input-phone:not(.ignore)').each((index, element) => {
            $(element).customPhoneInput();
        });
    }

    // Selection
    if ($('.selection:not(.ignore)').length > 0) {
        $('.selection:not(.ignore)').each((index, element) => {
            $(element).customSelection();
        });
    }

    // Prices Precision
    $(document).on('change', 'input[data-fixed]', function () {
        $(this).val(parseFloat($(this).val()).toFixed($(this).data('fixed')));
    });

    // DateRangePicker Icon
    $(document).on('click', '.input-group:has(.date-range) .input-group-append', function () {
        $(this).siblings('.date-range').trigger('focus');
    });

    // Toggle Button Change Text
    $(document).on('click', 'a[data-toggle]', function () {
        if ($(this).data('collapse-text') || $(this).data('expand-text')) {
            $(this).html($(this).hasClass('collapsed') ? $(this).data('collapse-text') : $(this).data('expand-text'));
        }
    });
});
